import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import MovdAuthCard from '../design-system/MovdAuthCard.jsx';
import MovdNotice from '../design-system/MovdNotice.jsx';
import MovdButton from '../design-system/MovdButton.jsx';

export default function VerifyEmailPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const [state, setState] = useState({ loading: true, success: false, message: '' });

  useEffect(() => {
    const token = new URLSearchParams(location.search).get('token');
    if (!token) {
      setState({ loading: false, success: false, message: 'Verification token is missing.' });
      return;
    }
    axios.get('/api/auth/verify-email', { params: { token } })
      .then(response => setState({ loading: false, success: true, message: response.data.message || 'Email verified successfully.' }))
      .catch(error => setState({ loading: false, success: false, message: error.response?.data?.error || 'Email verification failed.' }));
  }, [location.search]);

  return (
    <MovdAuthCard title="Verify your email">
      {state.loading ? (
        <div style={{ textAlign: 'center', padding: '32px 0' }}>
          <div aria-hidden="true" style={{ width: 32, height: 32, margin: '0 auto', borderRadius: '50%', border: '3px solid rgba(0,0,0,.1)', borderTopColor: '#1F8C82', animation: 'movd-spin 0.8s linear infinite' }} />
          <style>{'@keyframes movd-spin { to { transform: rotate(360deg); } }'}</style>
          <p style={{ marginTop: 16 }}>Verifying your email...</p>
        </div>
      ) : (
        <>
          <MovdNotice tone={state.success ? 'success' : 'error'}>{state.message}</MovdNotice>
          <MovdButton onClick={() => navigate(`/auth?returnTo=${encodeURIComponent('/?quotePayment=1')}`)} style={{ width: '100%', marginTop: 16 }}>
            Continue to sign in
          </MovdButton>
        </>
      )}
    </MovdAuthCard>
  );
}
